require('es6-promise').polyfill();

import Vue from 'vue';
import axios from 'axios';
import Config from '../config/app';

export const Axios = axios.create({
  baseURL: Config.apiUrl,
  timeout: Config.timeout,
  responseType: 'json'
});

// POST传参序列化(添加请求拦截器)
Axios.interceptors.request.use(
  config => {
    // config.headers.xAccessSign = Config.xAccessSign;
    // 如果有token
    if (sessionStorage.getItem(Config.tokenKey)) {
      config.headers.authorization = sessionStorage.getItem(Config.tokenKey);
    }

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 返回状态判断(添加响应拦截器)
Axios.interceptors.response.use(
  res => {
    if (res.data.token) {
      sessionStorage.setItem(Config.tokenKey, res.data.token);
      delete res.data[Config.tokenKey];
    }
    if (res.data.code) {
      res.data.code = Number(res.data.code);
      if (res.data.code === 444) {
        sessionStorage.removeItem(Config.tokenKey);
        Vue.$router.push({ path: '/login' });
      }
    }

    return res.data;
  },
  error => {
    try {
      if (error.code === 'ECONNABORTED') {
        console.log('netErr, timeout!');
        return Promise.resolve({ code: 1000, msg: 'netErr, timeout!' });
      } else {
        // 401 说明 token 验证失败, 500 服务器错误
        if (error.response.status === 401) {
          sessionStorage.removeItem(Config.tokenKey);
          location.href = Config.loginUrl;
        } else if (error.response.status === 500) {
          return Promise.resolve(error.response.data);
        }

        // 返回 response 里的错误信息
        return Promise.resolve(error.response.data);
      }
    } catch (e) {
      console.log(e.code);
    }
  }
);

export default Axios;

// export default {
//   install(Vue) {
//     Object.defineProperty(Vue.prototype, '$http', { value: Axios });
//   }
// };
